import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import slick from 'slick-carousel';

// Carousels that run on every page
// $(document).ready(function() {
//   $('.promo-slider').slick({
//     autoplay: true,
//     autoplaySpeed: 5000,
//     arrows: true,
//     centerMode: true,
//     slidesToShow: 1,
//     centerPadding: '0px',
//   });
// });

$(document).ready(function () {
  /* Author : Tyler Benton
     Date : 05/04/12
     jQuery : 1.7.2, works with 2.0.3
     Purpose : light weight countdown timer 
  */
  $.fn.countdown = function (options, callback) {
    // $obj = $(this);
    var obj = this;
    var $obj = $(obj);
    var settings = {
      numberFormat: null
    },
        interval = '';
    if (options) {
      $.extend(settings, options);
    }
    function init() {
      var newObj = '<ul><li><div class="days"></div></li><li><div class="hours"></div></li><li><div class="minutes"></div></li><li><div class="seconds"></div></li></ul>';
      $obj.append(newObj);
      countdown_process();
    }

    function countdown_process() {
      var eventDate = new Date($('#count-down').attr('datetime'));
      eventDate = Date.parse(eventDate) / 1000;
      var currentDate = Math.floor($.now() / 1000) + 0 * 3600;
      var seconds = eventDate - currentDate;
      var $days = $obj.find('.days');
      var $hours = $obj.find('.hours');
      var $minutes = $obj.find('.minutes');
      var $seconds = $obj.find('.seconds');
      var days = Math.floor(seconds / (24 * 60 * 60));
      seconds -= days * 24 * 60 * 60;
      var hours = Math.floor(seconds / (60 * 60));
      seconds -= hours * 60 * 60;
      var minutes = Math.floor(seconds / 60);
      seconds -= minutes * 60;
      if (eventDate <= currentDate) {
        callback.call(obj);
        clearInterval(interval);
        days = 0;
        seconds = 0;
        hours = 0;
        minutes = 0;
        seconds = 0;
      }
      if (settings.wordFormat === 'full') {
        days === 1 ? $days.attr('data-interval-text', 'day') : $days.attr('data-interval-text', 'days');
        hours === 1 ? $hours.attr('data-interval-text', 'hour') : $hours.attr('data-interval-text', 'hours');
        minutes === 1 ? $minutes.attr('data-interval-text', 'minute') : $minutes.attr('data-interval-text', 'minutes');
        seconds === 1 ? $seconds.attr('data-interval-text', 'second') : $seconds.attr('data-interval-text', 'seconds');
      } else {
        days === 1 ? $days.attr('data-interval-text', 'day') : $days.attr('data-interval-text', 'days');
        hours === 1 ? $hours.attr('data-interval-text', 'hr') : $hours.attr('data-interval-text', 'hrs');
        minutes === 1 ? $minutes.attr('data-interval-text', 'min') : $minutes.attr('data-interval-text', 'mins');
        seconds === 1 ? $seconds.attr('data-interval-text', 'sec') : $seconds.attr('data-interval-text', 'secs');
      }

      if (settings.numberFormat) {
        days = String(days).length >= 2 ? days : '0' + days;
        hours = String(hours).length >= 2 ? hours : '0' + hours;
        minutes = String(minutes).length >= 2 ? minutes : '0' + minutes;
        seconds = String(seconds).length >= 2 ? seconds : '0' + seconds;
      }

      if (!isNaN(eventDate)) {
        $days.text(days);
        $hours.text(hours);
        $minutes.text(minutes);
        $seconds.text(seconds);
      } else {
        console.log("Invalid date. Here's an example: 16 may 2012 11:59:59");
        clearInterval(interval);
      }
    }
    init();
    interval = setInterval(countdown_process, 1000);
  };
  var container = $('#count-down');
  function setCountdown(container) {
    $(container[0]).countdown({
      numberFormat: 'true'
    }, function () {});
  }

  setCountdown(container);

  // function setMarginOffset() {
  //   var bannerHeight = $('.promo-slider-wrapper').height();
  //   var headerHeight = $('.header__content-wrapper').height();

  //   var offset = bannerHeight + headerHeight + 24;
  //   console.log(offset, ' height');

  //   $('#shopify-section-header').css('margin-top', offset + 'px');

  //   $('#shopify-section-header').css('margin-top', offset + 'px');
  // }
  // setMarginOffset();
  // $(window).resize(function() {
  //   setMarginOffset();
  // });
});